import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FunctionComponent, memo } from "react";

import "./interaction-icon.scss";
import { IProps } from "./interaction-icon.types";
import { getInteractionIcon } from "./interaction-icon.utilities";

/**
 * Display consistent interaction type icons for all applications
 * @param props.interactionIconType     Interaction type
 * @param props.iconProps               Font awesome icon props
 */
const InteractionIcon: FunctionComponent<IProps> = ({ interactionIconType, ...iconProps }) => (
    <div className={`interaction-icon interaction-icon__${interactionIconType}`}>
        <FontAwesomeIcon
            title={interactionIconType}
            icon={getInteractionIcon(interactionIconType)}
            fixedWidth
            {...iconProps}
        />
    </div>
);

export default memo(InteractionIcon);
